import { useTerminalsState } from "@/States/Terminals";
import { useCommonEntitiesStore } from "@/States/commonEntities";
import { trpc } from "@/Utils/trpc";
import { getTimeFrame } from "@/components/pageCards/filterSort/filterTimeFrame";
import {
  INumberEntryProps,
  NumberCard,
} from "@/components/pageCards/numberCard";
import { useTrans } from "@/translations";

import { useMemo, useState } from "react";

import { FilterTimeFrameValue } from "server/config-api/index.js";

import { groupAndSortWasteTypes } from "../WasteTypesInUse/functions";

export const InfrastructureMWM = () => {
  const { t } = useTrans();
  const { allTerminals } = useTerminalsState();

  const [timeFrame] = useState(getTimeFrame(FilterTimeFrameValue.Last30Days));

  const { data: dwhData, isLoading } =
    trpc.dwh.terminals.getAggregates.useQuery(timeFrame, {
      queryKeyHashFn: () =>
        [
          "terminalAggregates",
          timeFrame.startTimeISO,
          timeFrame.endTimeISO,
        ].toString(),
    });

  const { wasteTypes: sanityWasteTypes } = useCommonEntitiesStore();

  const wasteTypesInUse = useMemo(
    () =>
      sanityWasteTypes && dwhData
        ? groupAndSortWasteTypes(
            dwhData?.terminalAggregates.wasteTypes || [],
            sanityWasteTypes,
          )
        : [],
    [dwhData, sanityWasteTypes],
  );

  const nrAccessParents = useMemo(
    () =>
      allTerminals.reduce((acc, terminal) => {
        acc += terminal.children?.length || 0;
        return acc;
      }, 0),
    [allTerminals],
  );

  const numbers: INumberEntryProps[] = [
    { heading: t("entities:terminals"), data: allTerminals!.length | 0 },
    { heading: t("entities:accessParents"), data: nrAccessParents },
    {
      heading: t("statisticsLabels:wasteCategories"),
      data: wasteTypesInUse.length | 0,
    },
  ];
  return (
    <NumberCard
      title="statisticsLabels:infrastructureSummary"
      numbers={numbers}
      isLoading={isLoading}
    />
  );
};
